import { Component, Input } from '@angular/core';

@Component({
  selector: 'muni-gameday-no-data',
  templateUrl: './no-data.template.html',
  styleUrls: ['./no-data.styles.scss']
})
export class NoDataComponent {
  @Input()
  public show: boolean;
  @Input()
  public message = false;
}
